module.exports = __webpack_public_path__ + "img/highlight-icon1-hover.a6d4c8fe.png";